// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bottomRightContent {
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    right: 0;
    height: 193px;
    width: 820px;
    position: absolute;
    padding-bottom: 20px;
}

.legendWrapper {
    height: calc(90% - 15px);
    width: calc(50% - 10px);
    margin-left: 5px;
    margin-top: 5px;
    border: 1px solid silver;
    position: relative;
    float: left;
}

.interactionWrapper {
    height: calc(20% - 5px);
    width: calc(50% - 10px);
    margin-left: 5px;
    margin-top: 5px;
    position: relative;
    border: 1px solid silver;
    float: left;
}

.interactionControl {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
}

.colorPicker {
    max-height: 100%;
    max-width: 50%;
}

#colorPicker {
    height: 120%;
    width: 50%;
}

#colorReset {
    height: 100%;
}

#customScale {
    max-height: 100%;
    right: 0;
    cursor: pointer;
    margin-left: 0px;
    margin-right: 10px;
}

.toggleSparklines {
    max-height: 100%;
    cursor: pointer;
    margin-right: 10px;
    border: 0px solid yellow;
}

.legendCanvas {
    position: absolute;
    top: 0;
    left: 0;
}

.legendWrapper img {
    height: 50%;
    width: 100%;
    position: absolute;
    bottom: 0;
}

.legendLabel {
    position: absolute;
    bottom: 0;
    color: black;
    width: 100%;
    overflow-wrap: break-word;
    z-index: 1;
}

.ordinalLegend {
    height: 100%;
    width: 100%;
    position: inherit;
}

.ordinalLabel {
    color: rgb(0, 0, 0);
    cursor: pointer;
    height: calc(50% - 10px);
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
    float: left;
    overflow-wrap: break-word;
}

.legendChart {
    width: 100%;
    height: 50%;
    position: absolute;
    top: 0;
}

.deselectedCategory {
    opacity: 0.3;
}

.custom-select {
    color: white;
    background-color: #333;
    width: 80%;
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;
    border-radius: 5px;
}

.custom-select option {
    color: white;
    text-align: center;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/css/legends.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["#bottomRightContent {\n    background: rgba(0, 0, 0, 0.6);\n    bottom: 0;\n    right: 0;\n    height: 193px;\n    width: 820px;\n    position: absolute;\n    padding-bottom: 20px;\n}\n\n.legendWrapper {\n    height: calc(90% - 15px);\n    width: calc(50% - 10px);\n    margin-left: 5px;\n    margin-top: 5px;\n    border: 1px solid silver;\n    position: relative;\n    float: left;\n}\n\n.interactionWrapper {\n    height: calc(20% - 5px);\n    width: calc(50% - 10px);\n    margin-left: 5px;\n    margin-top: 5px;\n    position: relative;\n    border: 1px solid silver;\n    float: left;\n}\n\n.interactionControl {\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: row;\n}\n\n.colorPicker {\n    max-height: 100%;\n    max-width: 50%;\n}\n\n#colorPicker {\n    height: 120%;\n    width: 50%;\n}\n\n#colorReset {\n    height: 100%;\n}\n\n#customScale {\n    max-height: 100%;\n    right: 0;\n    cursor: pointer;\n    margin-left: 0px;\n    margin-right: 10px;\n}\n\n.toggleSparklines {\n    max-height: 100%;\n    cursor: pointer;\n    margin-right: 10px;\n    border: 0px solid yellow;\n}\n\n.legendCanvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.legendWrapper img {\n    height: 50%;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n}\n\n.legendLabel {\n    position: absolute;\n    bottom: 0;\n    color: black;\n    width: 100%;\n    overflow-wrap: break-word;\n    z-index: 1;\n}\n\n.ordinalLegend {\n    height: 100%;\n    width: 100%;\n    position: inherit;\n}\n\n.ordinalLabel {\n    color: rgb(0, 0, 0);\n    cursor: pointer;\n    height: calc(50% - 10px);\n    padding-top: 5px;\n    padding-bottom: 5px;\n    text-align: center;\n    float: left;\n    overflow-wrap: break-word;\n}\n\n.legendChart {\n    width: 100%;\n    height: 50%;\n    position: absolute;\n    top: 0;\n}\n\n.deselectedCategory {\n    opacity: 0.3;\n}\n\n.custom-select {\n    color: white;\n    background-color: #333;\n    width: 80%;\n    text-align: center;\n    margin-left: 10%;\n    margin-right: 10%;\n    border-radius: 5px;\n}\n\n.custom-select option {\n    color: white;\n    text-align: center;\n    border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
